export const locationsTypes = {
  POINT: 'POINT',
  GRID: 'GRID'
}
